function About () {
    return (
        <div className="about card card--container">
             <h2 className="about-title">About</h2>
             <p className="about-info">I am a Pharmacist and an intermediate developer with a particular interest in making things simple
              and automating daily tasks. I try to keep up with security and best practices, and am always looking 
              for new things to learn.</p>
         </div>

    )
}
export default About;
